/* eslint-disable max-len */
import React from 'react';

export default function VideoIcon() {
  return (
    <svg width="52" height="37" fill="none" viewBox="0 0 52 37">
      <path
        fill="url(#paint0_linear_10353_4353)"
        d="M48.496 0H3.504A3.504 3.504 0 000 3.504V9.28l3.62 8.603L0 27.445v5.777a3.504 3.504 0 003.504 3.504h44.992A3.504 3.504 0 0052 33.222v-5.777l-1.693-9.885L52 9.28V3.504A3.504 3.504 0 0048.496 0zM8.973 33.475a.7.7 0 01-.701.7h-2.78a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.78a.7.7 0 01.7.7v2.779zm0-27.445a.7.7 0 01-.701.7h-2.78a.7.7 0 01-.7-.7V3.25a.7.7 0 01.7-.7h2.78a.7.7 0 01.7.7v2.78zm7.647 27.445a.7.7 0 01-.701.7H13.14a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.779zm0-27.445a.7.7 0 01-.701.7H13.14a.7.7 0 01-.7-.7V3.25a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.779zm0-27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7V3.25a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.779zm0-27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7V3.25a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.779zm0-27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7V3.25a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.779zm0-27.445a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7V3.25a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78z"
      />
      <path
        fill="url(#paint1_linear_10353_4353)"
        d="M1.198 24.293L0 27.445v5.777a3.504 3.504 0 003.504 3.504h44.992A3.504 3.504 0 0052 33.222v-5.777l-.584-3.152H1.198zm7.775 9.182a.7.7 0 01-.701.7h-2.78a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.78a.7.7 0 01.7.7v2.78zm7.647 0a.7.7 0 01-.701.7H13.14a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 0a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 0a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 0a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78zm7.647 0a.7.7 0 01-.701.7h-2.779a.7.7 0 01-.7-.7v-2.779a.7.7 0 01.7-.7h2.779a.7.7 0 01.7.7v2.78z"
      />
      <path
        fill="url(#paint2_linear_10353_4353)"
        d="M13.3 27.406h25.406a.909.909 0 00.908-.908V10.15a.909.909 0 00-.908-.91H13.299a.909.909 0 00-.908.91v16.347c0 .501.406.908.908.908z"
      />
      <path
        fill="url(#paint3_linear_10353_4353)"
        d="M0 27.445h8.064a.909.909 0 00.909-.91V10.19a.909.909 0 00-.91-.909H0v18.165z"
      />
      <path
        fill="url(#paint4_linear_10353_4353)"
        d="M43.028 10.189v16.347c0 .502.406.909.908.909H52V9.28h-8.064a.909.909 0 00-.908.909z"
      />
      <defs>
        <linearGradient
          id="paint0_linear_10353_4353"
          x1="8.055"
          x2="31.741"
          y1="0.418"
          y2="24.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A5A5A" />
          <stop offset="1" stopColor="#464646" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10353_4353"
          x1="26"
          x2="26"
          y1="29.909"
          y2="35.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#464646" stopOpacity="0" />
          <stop offset="1" stopColor="#202020" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_10353_4353"
          x1="11.101"
          x2="42.19"
          y1="18.324"
          y2="18.324"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF4FF" />
          <stop offset="1" stopColor="#CFE7FD" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_10353_4353"
          x1="-0.425"
          x2="9.822"
          y1="18.362"
          y2="18.362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF4FF" />
          <stop offset="1" stopColor="#CFE7FD" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_10353_4353"
          x1="42.603"
          x2="52.849"
          y1="18.362"
          y2="18.362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EEF4FF" />
          <stop offset="1" stopColor="#CFE7FD" />
        </linearGradient>
      </defs>
    </svg>
  );
}
